<script lang="ts" setup>
import Link7 from '@/components/Button/Link7.vue'
import type { ArticleCategory } from '@/utils/types/Article'

const props = defineProps({
  categories: {
    type: Array as PropType<ArticleCategory[]>,
    default: () => []
  },
  handleChangeFilterPage: {
    type: Function as PropType<(page: number, filter: any) => void>,
    default: () => { }
  },
  filter: {
    type: Object as PropType<{
      brand: string
      tool: string
      method: string
      ingredient: string
      category: string
    }>,
    default: () => ({
      brand: '',
      tool: '',
      method: '',
      ingredient: '',
      category: ''
    })
  }
})

const route = useRoute()
const themeCategory = (id: any) => {
  const category = props.categories.find(item => item.id === id)
  return category ? category.children : []
}
const filterItems = computed(() => [
  {
    target: 'brand',
    title: '品牌',
    items: themeCategory(6)
  },
  {
    target: 'tool',
    title: '廚具器材',
    items: themeCategory(5)
  },
  {
    target: 'method',
    title: '調理方式',
    items: themeCategory(2)
  },
  {
    target: 'ingredient',
    title: '選擇食材',
    items: themeCategory(4)
  },
  {
    target: 'category',
    title: '食譜類別',
    items: themeCategory(3)
  }
])

const select = ref({
  brand: props.filter.brand,
  tool: props.filter.tool,
  method: props.filter.method,
  ingredient: props.filter.ingredient,
  category: props.filter.category,
})

const handleSearch = () => {
  props.handleChangeFilterPage(1, select.value)
}
</script>

<template>
  <section class="filter">
    <div class="filter__item" v-for="f in filterItems" :key="f.title">
      <el-select v-model="select[f.target as 'brand' | 'tool' | 'method' | 'ingredient' | 'category']"
        class="h-select4 w-full" :placeholder="f.title">
        <el-option :label="f.title" value="" />
        <el-option :label="item.subject" :value="item.id.toString()" v-for="item in f.items" :key="item.id" />
      </el-select>
    </div>
    <div class="filter__item">
      <Link7 linkTitle="送出搜尋" icon="icon-search" @click="handleSearch" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.filter {
  display: flex;

  @include max-media(767) {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__item {
    width: 100%;
    max-width: toRem(160);

    @include max-media(767) {
      width: calc((100% - toRem(24)) / 3);
      max-width: 100%;
      margin-bottom: toRem(12);
    }

    @include max-media(480) {
      width: calc((100% - toRem(12)) / 2);
    }

    &:not(:last-child) {
      @include min-media(768) {
        margin-right: toRem(12);
      }
    }
  }

  :deep(.link) {
    width: 100%;
    padding: toRem(6) toRem(8) toRem(6) toRem(16);
    color: $color-white-1;
    justify-content: space-between;
    background-color: $color-brand-4_1;
  }

  :deep(.link__title) {
    font-size: toRem(14);
  }

  :deep(.link__icon) {
    color: $color-white-1;
  }
}
</style>
